import { useState } from 'react';
import { hotCards } from '@/mocks/home';

export default function HotFlow() {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <section id="hot" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-label text-secondary-600 tracking-[0.2em]">HOT LISTENING</span>
          <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl tracking-tight">
            热听大图卡片流
          </h2>
          <p className="mt-2 text-sm font-label text-foreground-600 max-w-xl leading-relaxed">
            封面即入口，点开就能看到这段录音讲了什么、关键句在哪一秒。
          </p>
        </div>
        <a
          href="#ranking"
          className="self-start whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-label text-primary-600 hover:text-primary-700 cursor-pointer"
        >
          查看完整收听榜
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {hotCards.map((card, index) => {
          const featured = index === 0;
          const isActive = activeId === card.id;
          return (
            <article
              key={card.id}
              className={`group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-colors hover:border-primary-200 ${
                featured ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full ${featured ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.cover}
                  alt={`${card.title} 黑料吃话对话录音封面`}
                  title={`${card.title} - 黑料吃话原声`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>

                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-[11px] font-label text-accent-950 whitespace-nowrap">
                  {card.tag}
                </span>

                <button
                  type="button"
                  onClick={() => setActiveId(isActive ? null : card.id)}
                  className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-background-50/95 text-xs font-label text-foreground-900 hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={isActive ? 'ri-pause-fill text-base text-primary-500' : 'ri-play-fill text-base text-primary-500'}></i>
                  {isActive ? '试听中' : '试听'}
                </button>
              </div>

              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center gap-3 text-[11px] font-label text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line text-sm"></i>
                    {card.duration}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-headphone-line text-sm"></i>
                    {card.listens}
                  </span>
                  <span className="ml-auto whitespace-nowrap">{card.date}</span>
                </div>

                <h3 className="mt-2.5 font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm font-label text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>

                {isActive && (
                  <div className="mt-3 flex items-center gap-2 text-[11px] font-label text-secondary-700 animate-fade-up">
                    <span className="flex items-end gap-0.5 h-3.5">
                      <span className="w-0.5 h-2 bg-secondary-500 rounded-full animate-subtle-pulse"></span>
                      <span className="w-0.5 h-3.5 bg-secondary-500 rounded-full animate-subtle-pulse"></span>
                      <span className="w-0.5 h-1.5 bg-secondary-500 rounded-full animate-subtle-pulse"></span>
                    </span>
                    正在展示试听入口 · 完整音频请进入条目
                  </div>
                )}

                <a
                  href="#top"
                  className="mt-4 inline-flex items-center gap-1.5 text-xs font-label text-primary-600 hover:text-primary-700 cursor-pointer"
                >
                  查看对话文字稿
                  <i className="ri-arrow-right-s-line"></i>
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}